import React, {Component} from "react";
import {
  Accordion,
  Container,
  Dimmer,
  Divider,
  Form,
  Grid,
  Icon, Input, Label,
  Loader,
  Message,
  Segment,
  Table
} from "semantic-ui-react";
import _ from 'lodash';
import SearchOrder from "./searchOrder";
import {Pagination} from "../utils/pagination";
import history from "../../history";
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import {bindActionCreators} from "redux";
import * as actions from "../../actions";
import {connect} from "react-redux";
import {l, t} from "../../i18n";

function getOrderDetails(type, code) {
  history.push(l+`/panel/orders/${type}/${code}`);
}

function mapStateToProps(state) {
  return {
    getOrders: state.getOrders,
  };
}

class Orders extends Component {

  constructor(props) {
    super(props);
    this.state = {
      orderTypes: [
        {text: 'Collect', value: 'collect', checked: false},
        {text: 'Direct', value: 'direct', checked: false},
        {text: 'Forward', value: 'forward', checked: false},
        {text: 'Split', value: 'split', checked: false},
      ],
      options: [
        {text: t("filter.options.choose"), value: 'choose date type'},
        {text: t("filter.options.equal"), value: 'simple_date'},
        {text: t("filter.options.between"), value: 'is_between'},
        {text: t("filter.options.last"), value: 'in_the_last'},
        {text: t("filter.options.before"), value: 'before_date'},
        {text: t("filter.options.after"), value: 'after_date'},
      ],
      activeIndex: 0,
      activeIndexDate: 0,
      activeIndexType: 0,
      activeIndexFilter: 0,
      activeIndexStatus: 0,
      orderStatuses: [
        {text: t("orders.status.defined"), value: 'defined', checked: false},
        {text: t("orders.status.completed"), value: 'completed', checked: false},
        {text: t("orders.status.failed"), value: 'failed', checked: false},
        {text: t("orders.status.open"), value: 'open', checked: false},
        {text: t("orders.status.cancelled"), value: 'cancelled', checked: false},
        {text: t("orders.status.partiallyCompleted"), value: 'partially_completed', checked: false},
        {text: t("orders.status.paymentReceived"), value: 'payment_received', checked: false},
        {text: t("orders.status.processed"), value: 'processed', checked: false},
      ],
      data: [],
      meta: {
        count: '',
        current_page: '',
        per_page: '',
        last_page: '',
        to: null,
      },
      loading: true,
      page: 1,
      nextPage: '',
      prevPage: '',
      pages: [],
      search: ''
    }
  }

  componentDidMount() {
    this.props.actions.getOrders()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.getOrders !== this.props.getOrders) {
      let orders = this.props.getOrders
      if (orders) {
        this.setState({data: orders.data, meta: orders.meta, loading: false})
      }
    }

    if (this.state.find) {
      this.find()
    }
  }

  find() {
    const {orderStatuses, orderTypes, search, dateType, lastDate, date, dateFrom, dateTo} = this.state;

    let statuses = [];
    orderStatuses.filter(item => item.checked === true).map(filtered => statuses.push(filtered.value))
    let types = [];
    orderTypes.filter(item => item.checked === true).map(filtered => types.push(filtered.value))

    let filter = {};
    if (statuses.length > 0) filter.status = statuses;
    if (types.length > 0) filter.type = types;
    if (search && search.length > 2) filter.code = search;

    if (dateType === 'in_the_last' && lastDate) filter.in_the_last = lastDate;
    else if (dateType === 'before_date' && date) filter.before_date = date;
    else if (dateType === 'after_date' && date) filter.after_date = date;
    else if (dateType === 'simple_date' && date) filter.specific_date = date;
    else if (dateType === 'is_between' && dateFrom && dateTo) filter.between_date = [dateFrom, dateTo];

    let queryData = {filter: filter};

    this.props.actions.getOrders(queryData);
    this.setState({queryData, find: false})
  }

  callPagination(options) {
    this.setState({
      current_page: options.pageNo,
      page: options.name,
      pages: options.pages,
      last_page: options.pagesCount,
      offset: options.offset,
      per_page: options.limit,
      showErrors: false,
      value: '',
    });
    let params = options.params;
    if (this.state.status)
      params.status = this.state.status;

    let query = this.state.queryData;
    let data = {
      page: options.pageNo,
      limit: 10,
      ...query
    }

    this.props.actions.getOrders(data);
  }

  handleFormInputClick = (event, data) => {
    const orderStatuses = this.state.orderStatuses.map(status => {
      if (data.value === status.value) {
        status.checked = data.checked
      }
      return status;
    })

    this.setState({orderStatuses, find: true})
  }

  handleSearchChange(event) {
    let search = event.target.value
    this.setState({search, find: true})
  }

  handleFormTypeClick = (event, data) => {
    const orderTypes = this.state.orderTypes.map(type => {
      if (data.value === type.value) {
        type.checked = data.checked
      }
      return type;
    })

    this.setState({orderTypes, find: true})
  }

  changeDate = (e, date) => {
    if (null === date.value) {
      this.setState({date: null, find: true})
    } else {
      let datePicker = this.parseDate(date.value)
      this.setState({
        date: datePicker,
        find: true,
      });
    }
  };

  changeDateFrom = (e, date) => {
    if (null !== date.value) {
      let datePicker = this.parseDate(date.value)
      this.setState({
        dateFrom: datePicker,
      });
    } else {
      this.setState({dateFrom: null, find: true})
    }
  }

  changeDateTo = (e, date) => {
    if (null !== date.value) {
      let datePicker = this.parseDate(date.value)
      this.setState({
        dateTo: datePicker, find: true
      });
    } else {
      this.setState({dateTo: null, find: true})
    }
  }

  parseDate = (date) => date.getFullYear() + "-" + parseInt(date.getMonth() + 1) + "-" + date.getDate();
  handleChange = (e) => this.setState({dateType: e.target.value});

  handleClickDate = (e, titleProps) => {
    const {index} = titleProps;
    const {activeIndexDate} = this.state;
    const newIndex = activeIndexDate === index ? -1 : index;
    this.setState({
      activeIndexDate: newIndex,
    });
  }

  handleClickStatus = (e, titleProps) => {
    const {index} = titleProps;
    const {activeIndexStatus} = this.state;
    const newIndex = activeIndexStatus === index ? -1 : index;
    this.setState({
      activeIndexStatus: newIndex,
    });
  }

  handleClickType = (e, titleProps) => {
    const {index} = titleProps;
    const {activeIndexType} = this.state;
    const newIndex = activeIndexType === index ? -1 : index;
    this.setState({
      activeIndexType: newIndex,
    });
  }

  handleClickFilter = (e, titleProps) => {
    const {index} = titleProps;
    const {activeIndexFilter} = this.state;
    const newIndex = activeIndexFilter === index ? -1 : index;
    this.setState({
      activeIndexFilter: newIndex,
    });
  }

  handleInputChange = (e, data) => this.setState({lastDate: data.value, find: true})

  labelStatuses(status) {
    if (status === 'completed') {
      return <Label color="green">{status}</Label>
    } else if (status === 'failed') {
      return <Label color="red">{status}</Label>
    } else if (status === 'defined') {
      return <Label color="blue">{status}</Label>
    } else {
      return <Label>{status}</Label>
    }
  }

  render() {
    const {activeIndexFilter, activeIndexDate, activeIndexStatus, activeIndexType, dateType, options} = this.state
    let order = this.state.data;
    let meta = this.state.meta;

    if (order && order.length === 1) {
      meta.current_page = 1;
      meta.last_page = 1;
      meta.per_page = 1
    }

    return (
      <Container>
        <Dimmer inverted active={this.state.loading}>
          <Loader content={t("system.loading")}/>
        </Dimmer>
        <Segment basic>
          <Divider horizontal className='list-title'>{t("orders.ordersList")}</Divider>
          <Grid stackable>
            {this.state.showErrors &&
            <Segment basic>
              <Message error
                       list={this.state.formErrors}
              />
            </Segment>}
            <Grid.Row columns={2} className="filterBar">
              <Grid.Column floated='left' width={5}>
                <SearchOrder
                  handleSearch={this.handleSearchChange.bind(this)}
                  valuesSearch={this.state.valueSearch}
                />
              </Grid.Column>
              <Grid.Column floated='right' width={5} style={{zIndex: 10}}>
                <Accordion styled style={{zIndex: 10}}>
                  <Accordion.Title
                    content={t("orders.filterOrders")}
                    active={activeIndexFilter === 1}
                    index={1}
                    onClick={this.handleClickFilter}
                    id="filter-list-header"
                    icon={"filter"}
                  />
                  <Accordion.Content active={activeIndexFilter === 1}>
                    <Accordion.Title
                      active={activeIndexType === 1}
                      content={t("orders.orderTypes")}
                      index={1}
                      onClick={this.handleClickType}
                      className="filter-list-title"
                    />
                    <Accordion.Content active={activeIndexType === 1}>
                      <Form>
                        <Form.Group grouped>
                          {this.state.orderTypes.map((type) => (
                            <Form.Checkbox
                              key={type.value}
                              label={type.text}
                              value={type.value}
                              checked={this.state.orderTypes.checked}
                              onClick={this.handleFormTypeClick.bind(this)}/>
                          ))}
                        </Form.Group>
                      </Form>
                    </Accordion.Content>
                    <Accordion.Title
                      active={activeIndexDate === 1}
                      index={1}
                      onClick={this.handleClickDate}
                      content={t("orders.date")}
                      className="filter-list-title"
                    />
                    <Accordion.Content active={activeIndexDate === 1}>
                      <Grid>
                        <Grid.Row>
                          <Grid.Column floated={"left"}>
                            <Form>
                              <Form.Group widths='equal'>
                                <Form.Field control='select' style={{padding: "5px"}} onChange={this.handleChange}>
                                  {options.map(option => (
                                    <option key={option.value} value={option.value}>{option.text}</option>
                                  ))}
                                </Form.Field>
                              </Form.Group>
                            </Form>
                          </Grid.Column>
                        </Grid.Row>
                        {dateType === 'in_the_last' &&
                        <Grid>
                          <Grid.Row>
                            <Grid.Column>
                              <Input
                                size={"mini"}
                                icon='search'
                                placeholder={t("orders.days")}
                                onChange={this.handleInputChange}
                                type="number"
                                min="1"
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>}
                        {(dateType === 'simple_date' || dateType === 'before_date' || dateType === 'after_date') &&
                        <Grid>
                          <Grid.Row>
                            <Grid.Column>
                              <SemanticDatepicker
                                locale="en-US"
                                onChange={this.changeDate}
                                datePickerOnly={true}
                                size={"mini"}
                                pointing={"right"}
                                clearable
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>}
                        {dateType === 'is_between' &&
                        <Grid>
                          <div>{t("orders.from")}</div>
                          <Grid.Row>
                            <Grid.Column>
                              <SemanticDatepicker
                                locale="en-US"
                                onChange={this.changeDateFrom}
                                datePickerOnly={true}
                                size={"mini"}
                                pointing={"right"}
                              />
                            </Grid.Column>
                          </Grid.Row>
                          <div>{t("orders.to")}</div>
                          <Grid.Row>
                            <Grid.Column>
                              <SemanticDatepicker
                                locale="en-US"
                                onChange={this.changeDateTo}
                                datePickerOnly={true}
                                size={"mini"}
                                pointing={"right"}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>}
                      </Grid>
                    </Accordion.Content>
                    <Accordion.Title
                      active={activeIndexStatus === 1}
                      content={t("orders.status")}
                      index={1}
                      onClick={this.handleClickStatus}
                      className="filter-list-title"
                    />
                    <Accordion.Content active={activeIndexStatus === 1} style={{zIndex: 10000}}>
                      <Form>
                        <Form.Group grouped>
                          {this.state.orderStatuses.map((option) => (
                            <Form.Checkbox
                              key={option.value}
                              label={option.text}
                              value={option.value}
                              checked={this.state.orderStatuses.checked}
                              onClick={this.handleFormInputClick.bind(this)}/>
                          ))}
                        </Form.Group>
                      </Form>
                    </Accordion.Content>
                  </Accordion.Content>
                </Accordion>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Table selectable={order.length > 0} compact columns='4' id="table">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign={"center"}>{t("orders.code")}</Table.HeaderCell>
                <Table.HeaderCell textAlign={"center"}>{t("orders.type")}</Table.HeaderCell>
                <Table.HeaderCell textAlign={"center"}>{t("orders.updated")}</Table.HeaderCell>
                <Table.HeaderCell textAlign={"center"}>{t("orders.status")}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            {order && <Table.Body>
              {_.map(order, ({data}) => (
                <Table.Row key={data.code} onClick={getOrderDetails.bind(this, data.type, data.code)}>
                  <Table.Cell textAlign={"center"}>{data.code}</Table.Cell>
                  <Table.Cell textAlign={"center"}>{data.type}</Table.Cell>
                  <Table.Cell textAlign={"center"}>{data.updatedAt}</Table.Cell>
                  <Table.Cell textAlign={"center"}>{this.labelStatuses(data.status)}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>}
            {order.length === 0 && <Table.Body>
              <Table.Row textAlign="center">
                <Table.Cell colSpan={"4"}>
                  <Icon name={'search'}/>{t("orders.noResultFound")}
                </Table.Cell>
              </Table.Row>
            </Table.Body>}
            <Table.Footer>
              <Pagination
                columnNumber={5} showFunction={this.callPagination.bind(this)}
                pageNo={meta.current_page} pages={this.state.pages}
                pagesCount={meta.last_page} limit={meta.per_page}/>
            </Table.Footer>
          </Table>
        </Segment>
      </Container>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {actions: bindActionCreators(actions, dispatch)};
}

export default connect(mapStateToProps, mapDispatchToProps)(Orders)
